export default __webpack_public_path__ + "2df9a0dfdc1d95ab02c4908872f5c358.svg";